/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelEmbed64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelEmbed64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            opacity="0.1"
            d="M12 15C12 13.3431 13.3431 12 15 12H49C50.6569 12 52 13.3431 52 15V49C52 50.6569 50.6569 52 49 52H15C13.3431 52 12 50.6569 12 49V15Z"
            fill="currentColor"
          />
          <g>
            <path
              d="M34.5152 24H33.4845L29.4845 40H30.5152L34.5152 24Z"
              fill="currentColor"
            />
            <path
              d="M22.7072 32L26.3536 35.6464L25.6465 36.3536L21.293 32L25.6465 27.6464L26.3536 28.3536L22.7072 32Z"
              fill="currentColor"
            />
            <path
              d="M37.6465 35.6464L41.293 32L37.6465 28.3536L38.3536 27.6464L42.7072 32L38.3536 36.3536L37.6465 35.6464Z"
              fill="currentColor"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 15C12 13.3431 13.3431 12 15 12H49C50.6569 12 52 13.3431 52 15V49C52 50.6569 50.6569 52 49 52H15C13.3431 52 12 50.6569 12 49V15ZM15 13H49C50.1046 13 51 13.8954 51 15V49C51 50.1046 50.1046 51 49 51H15C13.8954 51 13 50.1046 13 49V15C13 13.8954 13.8954 13 15 13Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelEmbed64Icon.tags = ['add', 'panel', 'embed', 'code'];

AddPanelEmbed64Icon.category = '64x64 (Add panel)';

AddPanelEmbed64Icon.iconSize = 64;
